// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/AleofontSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile Styles */
.homepage {
    padding: 10px;
    font-size: 14px;
}

.buttonRow { 
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}


.button {
    background-color: #12e172;
    padding: 16px 32px 16px 32px;
    border-radius: 9px;
    font-size: 18px;
    color: white;
    border: none;

    a {
        text-decoration: none;
        color: white;
    }
}

.button:hover {
    background-color: #0bb359;
}

.arrow {
    font-family: "AleoSans";
}

.headerContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.header {
    font-size: 3rem;
    max-width: 1200px;
    width: 100%;
    margin: 10rem auto 0;
    text-align: center;
}

.subheader {
    font-size: 1rem;
    text-align: center;
}

.secondSubheader {
    font-size: 16px;
    text-align: center;
    margin-top: 6rem;
}

.actionRow {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100rem;
    align-items: center;
    justify-content: space-between;
    margin: 5rem auto 0;
    padding-left: 0;
}

.actionRow a:nth-child(2),
a:nth-child(3) {
    margin-top: 2rem;
}

.actionItem {
    width: 200px;
    padding: 1rem 1rem 1rem 1rem;
    border: 2px solid white;
    border-radius: 20px;
    list-style-type: none;
    text-align: center;
    color: white;
    text-decoration: none;
    font-size: 1rem;
    align-content: center;
}

.actionItem:hover {
    background-color: #0bb359;
}

/* Desktop Styles */
@media (min-width: 1024px) {
    .homepage {
        padding: 20px;
        font-size: 18px;
    }

    .buttonRow { 
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .actionRow {
        display: flex;
        flex-direction: row;
        width: 100%;
        max-width: 800px;
        justify-content: space-between;
        margin: 10rem auto 0;
    }

    .header {
        font-size: 6rem;
        max-width: 1200px;
        width: 100%;
        margin: 10rem auto 0;
        text-align: center;
    }

    .subheader {
        font-size: 32px;
        width: 35rem;
        text-align: center;
    }

    .secondSubheader {
        font-size: 32px;
        width: 35rem;
        text-align: center;
        margin-top: 10rem;
    }

    .actionRow a:nth-child(2),
    a:nth-child(3) {
        margin-top: 0;
    }

    .actionItem {
        width: 175px;
        padding: 2rem 2rem 2rem 2rem;
        border: 2px solid white;
        border-radius: 30px;
        list-style-type: none;
        text-align: center;

        a {
            color: white;
            text-decoration: none;
            font-size: 24px;
            align-content: center;
        }
    }

    .actionItem:hover {
        background-color: #0bb359;
    }
}

@font-face {
    font-family: "AleoSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
    font-weight: normal;
    font-style: normal;
}

body {
    font-family: "AleoSans", sans-serif;
    color: white;
}

.logo {
    height: 2rem;
}

.footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Homepage.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;;AAGA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;;IAEZ;QACI,qBAAqB;QACrB,YAAY;IAChB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,gBAAgB;QAChB,8BAA8B;QAC9B,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,4BAA4B;QAC5B,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;QACrB,kBAAkB;;QAElB;YACI,YAAY;YACZ,qBAAqB;YACrB,eAAe;YACf,qBAAqB;QACzB;IACJ;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,uBAAuB;IACvB,+DAAoE;IACpE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":["/* Mobile Styles */\n.homepage {\n    padding: 10px;\n    font-size: 14px;\n}\n\n.buttonRow { \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n}\n\n\n.button {\n    background-color: #12e172;\n    padding: 16px 32px 16px 32px;\n    border-radius: 9px;\n    font-size: 18px;\n    color: white;\n    border: none;\n\n    a {\n        text-decoration: none;\n        color: white;\n    }\n}\n\n.button:hover {\n    background-color: #0bb359;\n}\n\n.arrow {\n    font-family: \"AleoSans\";\n}\n\n.headerContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.header {\n    font-size: 3rem;\n    max-width: 1200px;\n    width: 100%;\n    margin: 10rem auto 0;\n    text-align: center;\n}\n\n.subheader {\n    font-size: 1rem;\n    text-align: center;\n}\n\n.secondSubheader {\n    font-size: 16px;\n    text-align: center;\n    margin-top: 6rem;\n}\n\n.actionRow {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    max-height: 100rem;\n    align-items: center;\n    justify-content: space-between;\n    margin: 5rem auto 0;\n    padding-left: 0;\n}\n\n.actionRow a:nth-child(2),\na:nth-child(3) {\n    margin-top: 2rem;\n}\n\n.actionItem {\n    width: 200px;\n    padding: 1rem 1rem 1rem 1rem;\n    border: 2px solid white;\n    border-radius: 20px;\n    list-style-type: none;\n    text-align: center;\n    color: white;\n    text-decoration: none;\n    font-size: 1rem;\n    align-content: center;\n}\n\n.actionItem:hover {\n    background-color: #0bb359;\n}\n\n/* Desktop Styles */\n@media (min-width: 1024px) {\n    .homepage {\n        padding: 20px;\n        font-size: 18px;\n    }\n\n    .buttonRow { \n        display: flex;\n        flex-direction: row;\n        gap: 20px;\n    }\n\n    .actionRow {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n        max-width: 800px;\n        justify-content: space-between;\n        margin: 10rem auto 0;\n    }\n\n    .header {\n        font-size: 6rem;\n        max-width: 1200px;\n        width: 100%;\n        margin: 10rem auto 0;\n        text-align: center;\n    }\n\n    .subheader {\n        font-size: 32px;\n        width: 35rem;\n        text-align: center;\n    }\n\n    .secondSubheader {\n        font-size: 32px;\n        width: 35rem;\n        text-align: center;\n        margin-top: 10rem;\n    }\n\n    .actionRow a:nth-child(2),\n    a:nth-child(3) {\n        margin-top: 0;\n    }\n\n    .actionItem {\n        width: 175px;\n        padding: 2rem 2rem 2rem 2rem;\n        border: 2px solid white;\n        border-radius: 30px;\n        list-style-type: none;\n        text-align: center;\n\n        a {\n            color: white;\n            text-decoration: none;\n            font-size: 24px;\n            align-content: center;\n        }\n    }\n\n    .actionItem:hover {\n        background-color: #0bb359;\n    }\n}\n\n@font-face {\n    font-family: \"AleoSans\";\n    src: url(\"../../public/AleofontSans-Regular.otf\") format(\"opentype\");\n    font-weight: normal;\n    font-style: normal;\n}\n\nbody {\n    font-family: \"AleoSans\", sans-serif;\n    color: white;\n}\n\n.logo {\n    height: 2rem;\n}\n\n.footer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 10rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
